import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { ClassAttributes, createElement, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = ClassAttributes<HTMLElement> & {
  onClickAcceptButton: MouseEventHandler<HTMLElement>;
  onRequestClose: MouseEventHandler<HTMLElement>;
  open?: boolean;
  className?: string;
};

const DraftProjectDeleteDialog = ({ onClickAcceptButton, onRequestClose, open, className, key }: Props) => {
  const ariaLabelledBy = `draft-project-delete-dialog-title-${key}`;
  const ariaDescribedBy = `draft-project-delete-dialog-description-${key}`;

  return (
    <Dialog
      open={!!open}
      onClose={onRequestClose}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      className={className}
    >
      <DialogTitle id={ariaLabelledBy}>
        <FormattedMessage id="draft_project_delete_dialog.title" />
      </DialogTitle>

      <DialogContent>
        <DialogContentText id={ariaDescribedBy}>
          <FormattedMessage id="draft_project_delete_dialog.description" />
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="text" onClick={onRequestClose}>
          <FormattedMessage id="draft_project_delete_dialog.decline" />
        </Button>

        <Button variant="text" onClick={onClickAcceptButton} autoFocus>
          <FormattedMessage id="draft_project_delete_dialog.accept" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DraftProjectDeleteDialog;
